import { GetBalenaDeviceQuery } from './balena_schemas'
import { generateContext } from '../../utils'
import { DeviceDataType, DeviceListType, DeviceStationsType, DeviceType } from './index'

export interface IDeviceContext {
    // The device list has to land before a `?deviceId=` param can be resolved to a selection, so views
    // need to tell "still fetching" apart from "nothing selected".
    loadingFetchDevices: boolean
    loadingDeviceData: boolean
    deviceData: DeviceDataType | undefined
    devices: DeviceListType
    refreshDevices: () => void
    selectedDevice?: DeviceType | null
    setSelectedDevice: (device: DeviceType | null) => void
    deviceStations: DeviceStationsType | undefined
    editDiffConfig: (device_uuid: string | undefined, diff_config: any, resetFunc?: () => void) => void
    setDeviceForceUpdateAction: (device_uuid: string | undefined) => void
    getSelectedDeviceType: () => string | null | undefined
    targetCommit: string | undefined
    runningCommit: string | undefined
    balenaStatus: string | undefined
    loadingSaveBasicConfig: boolean
    loadingForceUpdate: boolean
    balenaDeviceData: GetBalenaDeviceQuery | undefined
}
const [DeviceContext, DeviceProvider] = generateContext<IDeviceContext>()
export { DeviceContext, DeviceProvider }
